import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import builders from '../../../../assets/images/builders.svg'
import iconLogo from '../../../../assets/logos/iconLogo.svg'
import CustomButton from '../../../common/CustomButton'
import AuthService from '../../../../services/AuthService'
import UserRoles from '../../../../constants/UserRoles'
import './style.sass'

const Login = () => {
  const history = useHistory()
  const session = useSelector(({ auth }) => auth.session)

  const onLoginClicked = () => {
    AuthService.instance.login()
  }

  const onContinueClicked = () => {
    let isAdmin = session?.profile?.role?.includes(UserRoles.SYSTEM_ADMIN)
    if (isAdmin) {
      history.push("/admin/dashboard") // TODO - Redirect to page user came from
    } else {
      history.push("/partner/dashboard") // Normal user
    }
  }

  return (
    <div className="login-component-container">
      <Container fluid={true} >
        <Row>
          <Col className="col-left">
            <img src={builders} alt='builders' />
          </Col>
          <Col className="col-right">
            <img src={iconLogo} alt='iconLogo' />
            <h1>Welcome to Softrig Integration Management</h1>

            {!session ? (
              <div>
                <h2>Login to continue</h2>
                <CustomButton
                  onClick={onLoginClicked}
                  buttonText="LOGIN"
                />
              </div>
            ) : (
              <div>
                <h2>You are logged in</h2>
                <CustomButton
                  onClick={onContinueClicked}
                  buttonText="Continue"
                />
              </div>
            )}

          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Login